export const REFERENCE_NODE_NAME = 'reference';
